export const pizza = [
  {
    id: "1",
    name: "Chicken Tikka",
    priceS: "580",
    priceM: "1000",
    priceL: "1450",
    priceXL: "1950",
    description: "Chicken tikka, onion, bell pepper, black olive",
  },
  {
    id: "2",
    name: "Chicken Fajita",
    priceS: "580",
    priceM: "1000",
    priceL: "1450",
    priceXL: "1950",
    description: "Chicken Fajita, onion & bell pepper",
  },
  {
    id: "3",
    name: "Chicken Supreme",
    priceS: "580",
    priceM: "1000",
    priceL: "1450",
    priceXL: "1950",
    description: "Tikka, Fajita, smoked chicken, onion, bell pepper",
  },
  {
    id: "4",
    name: "Hot & Spicy",
    priceS: "580",
    priceM: "1000",
    priceL: "1450",
    priceXL: "1950",
    description:
      "Spicy Chicken, Chicken Sausage, tomato, mushroom onion, bell pepper",
  },
  {
    id: "5",
    name: "Bone Fire",
    priceS: "580",
    priceM: "1000",
    priceL: "1450",
    priceXL: "1950",
    description:
      "Spicy Chicken, Chicken Sausage, tomato, mushroom onion, bell pepper",
  },
  {
    id: "6",
    name: "Achari Punjabi Pizza",
    priceS: "580",
    priceM: "1000",
    priceL: "1450",
    priceXL: "1950",
    description: "Chicken achari,Sausage, tomato, mushroom, black olive",
  },
  {
    id: "7",
    name: "Cheese lover",
    priceS: "530",
    priceM: "900",
    priceL: "1300",
    priceXL: "",
    description: "",
  },
  {
    id: "8",
    name: "Vegetable Pizza",
    priceS: "530",
    priceM: "900",
    priceL: "1300",
    priceXL: "",
    description: "",
  },
];
